(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracAdminCustomerAccountController', NasracAdminCustomerAccountController);
    //remove localstorage for data tables on Page reload
    window.localStorage.removeItem("DataTables_customerusersearchbar_/");

    NasracAdminCustomerAccountController.$inject = ['$scope', '$state', 'NasracAdminCustomerAccount', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile', 'AuthServerProvider', 'Principal' ];

    function NasracAdminCustomerAccountController ($scope, $state, NasracAdminCustomerAccount, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile, AuthServerProvider, Principal ) {
        var vm = this;
        vm.nasracAdminCustomerAccounts = [];
        vm.nasracAdminCustomerAccounts = {
        		createRoles: "Administrators,DAC Content Administrator"
        	};

        loadAll();

        var abbr = moment.tz(moment.tz.guess()).zoneAbbr();
        vm.dtOptions = DTOptionsBuilder.newOptions()
        .withOption('ajax', {
            contentType: 'application/json',
            url: '/api/nasrac-admin-customer-accounts/datatables-view',
            type: 'POST',
            beforeSend: function(xhr){
                xhr.setRequestHeader("Authorization",
                    "Bearer " + AuthServerProvider.getToken());
            },
            data: function(data, dtInstance) {
                data.columns.shift();
                data.order[0].column = data.order[0].column - 1;
                return JSON.stringify(data);
            }
        })
            .withOption('stateSave',true)
            .withDOM(
                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
                "<'row'<'col-sm-12'tr>>" +
                "<'row'<'col-sm-5'i><'col-sm-7'p>>")
        .withDataProp('data') // This is the name of the value in the returned recordset which contains the actual data
        .withOption('serverSide', true)
            .withBootstrapOptions({
                TableTools: {
                    classes: {
                        container: 'btn-group',
                        buttons: {
                            normal: 'btn btn-danger'
                        }
                    }
                },
                ColVis: {
                    classes: {
                        masterButton: 'btn btn-primary'
                    }
                },
                pagination: {
                    classes: {
                        ul: 'pagination pagination-sm'
                    }
                }
            }).withPaginationType('full_numbers')
            .withButtons([
                {
                    text: 'Export',
                    extend: "excelHtml5",
                    title:"Customer Account Types",
                    action: function (e, dt, node, config) {
                        NasracAdminCustomerAccount.download().$promise
                            .then(function (data) {
                                //console.log(data);
                                var url = URL.createObjectURL(data.response);
                                var link = document.createElement("a");
                                link.href = url;

                                //set the visibility hidden so it will not effect on your web-layout
                                link.style = "visibility:hidden";
                                link.download = "NAS-RAC_CustomerAccount.xlsx"; //this is an example file to download, use yours

                                //this part will append the anchor tag and remove it after automatic click
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                    },
                    exportOptions: {
                        columns: ':visible'
                    },
                    //CharSet: "utf8",
                    exportData: { decodeEntities: true }
                }
            ])

	.withDisplayLength(25)

	.withOption('createdRow', function (row) {
		// Recompiling so we can bind Angular directive to the DT
	        $compile(angular.element(row).contents())($scope);
	})
	.withOption('saveState', true)
	.withOption('order', [1, 'asc'])
    .withOption("lengthMenu", [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]]);

        vm.dtColumns = [
        	DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '85px').notSortable()
            .renderWith(actionsHtml),
              DTColumnBuilder.newColumn('siteId').withTitle('Site Id'),
              DTColumnBuilder.newColumn('firstName').withTitle('First Name'),
              DTColumnBuilder.newColumn('lastName').withTitle('Last Name'),
              DTColumnBuilder.newColumn('email').withTitle('Email'),
              DTColumnBuilder.newColumn('phone').withTitle('Phone'),
              //DTColumnBuilder.newColumn('address').withTitle('Address'),
              //DTColumnBuilder.newColumn('city').withTitle('City'),
              //DTColumnBuilder.newColumn('country').withTitle('Country'),
              //DTColumnBuilder.newColumn('state').withTitle('State'),
              //DTColumnBuilder.newColumn('zipcode').withTitle('Zipcode'),
              DTColumnBuilder.newColumn('launchDate').withTitle('Launch Date').renderWith(function(data,type,full) {
            	  data = $filter('date')(data, 'EEE MM/dd/yyyy hh:mm a ');
            	  if (data) {
            		  data += abbr;
            	  }
                  return data;

              })

        ];

        if (Principal.hasAnyAuthority(['DAC Content User'])){
        	vm.dtColumns[0].visible = false;
        }

        function loadAll() {
            NasracAdminCustomerAccount.query(function(result) {
                vm.nasracAdminCustomerAccounts = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta){
            return GUIUtils.getActionsTemplate(data, $state.current.name, ['update', 'delete']);
        }

        function search() {
        vm.dtInstance.reloadData();
        }

        // vm.dtOptions.withOption("stateSave",true);
        // if($rootScope.IsSuccess==true) {
        //     if(vm.dtInstance!=undefined) {
        //         vm.dtInstance.DataTable.state.clear();
        //         //vm.dtInstance.reloadData();
        //         vm.dtInstance.DataTable.rerender();
        //     }
        //     vm.dtOptions.withOption("stateSave",true);
        // }
        // else {
        //
        //     //vm.dtOptions.withOption("stateSave",false);
        //     if(vm.dtInstance!=undefined) {
        //         vm.dtInstance.DataTable.state.clear();
        //         // vm.dtInstance.reloadData();
        //         vm.dtInstance.DataTable.rerender();
        //     }
        // }
    }
})();
